export default __webpack_public_path__ + "static/media/CapaGroupChatMobile.f1917c05.png";